<template>
  <div class="content">
    <div class="content">
      <div class="md-layout">
        <div
            class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <p-s-table
                  tableHeaderColor="purple"
                  title="Meine Artikel"
                  subTitle="von Firma Mustermann"
                  showFilter="true"
                  sortBy="customerArticleNumber"
                  v-bind:data="this.articles"
                  v-bind:dict="this.articlesDict"
                  hasCheckbox="true"
                  v-bind:onSelectCheckbox="this.onSelect"
          ></p-s-table>
        </div>
        <md-button class="md-primary" style="margin-left: auto; margin-right: 20px;" v-on:click="postTender()">Anfrage senden</md-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { PSTable } from "@/components";
  import store from '@/store/index.js';
  import api from "@/api/api";

export default {
  name: "PriceBenchmarkCreateNew",
  components: { PSTable },
  data() {
    return {
      articles: [],
      articlesDict: [
        { key: 'customerArticleNumber', label: 'Artikelnummer', type: 'string'},
        { key: 'customerArticleDescription', label: 'Bezeichnung', type: 'string'},
        { key: 'supplier', label: 'Lieferant', type: 'string'},
        { key: 'container', label: 'Anzahl Behälter', type: 'string'},
        { key: 'quantity', label: 'Gesamtmenge', type: 'number'}
      ]
    }
  },
  created () {
    store.commit("setLoading", true);

    api.getArticles().then((result) => {
      this.articles = result.data;

      store.commit("setLoading", false);
    });
  },
  methods: {
    postTender() {
      api.postSelectedArticlesForTender().then((result) => {
        if (result.status === 200) {
          this.$notify(
              {
                message: 'Die Preisausschreibung wurde an uns übermittelt. Wir melden uns bei Ihnen sobald sich die Lieferanten dazu gemeldet haben!',
                icon: 'check',
                horizontalAlign: "top",
                verticalAlign: "center",
                type: "success",
                timeout: 10000
              });

          store.commit("setSelectedArticles", null);

          this.$router.push("/app/price-benchmark/");
        }
      });
    },
    onSelect(val) {
      store.commit("setSelectedArticles", val);
    }
  }
};
</script>

